import React, { useState, useEffect, useRef, useContext } from "react";

// Librerias de componentes
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

// Componentes de Base
import Card from "../../../../../Base/Components/Card/Card";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
// import CrudCustomersModal from "./ModalCustomers/CrudCustomersModal";
import { getCustomersDetails } from "../../../../../API/Compras/Customers/CustomerDetails/CustomerDetailsRequest";
import CustomerDetailsCrud from "./CustomerDetailsCRUD/CustomerDetailsCrud";



// import './categoriaStyle.scss';

export const CustomerDetailsScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [customerDetails, setCustomerDetails] = useState("");
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const cust = await getCustomersDetails();
    // console.log(">>>>>", cust);
    setCustomerDetails(cust);
    setLoading(false);
  };


  const colums = [
    {
      field: "IdCustomerDetails",
      header: "ID",
      className: "Xsmall",
      frozen: true,
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
        field: "CompanyName",
        header: "Detalle de Cliente",
        headerEn: "Customer Detail",
        className: "XXlarge",
        frozen: true,
        onCellDoubleClicked: ({ data }) => {
          setShowDialog(true);
          setSelected(data);
        },
      },
      {
        field: "CustomerName",
        header: "Nombre",
        headerEn: "Name",
        className: "Xlarge",
        frozen: true,
        onCellDoubleClicked: ({ data }) => {
          setShowDialog(true);
          setSelected(data);
        },
      },
      {
        header: "Estado",
        headerEn: "Status",
        field: "IdStatus",
        className: "small",
        Format: "Estado",     
        filter: false, 
        body: (rowData) => ({ ID: rowData.StatusName, Estado: rowData.StatusName }),
      },
      {
        field: "RTN",
        header: "RTN",
        className: "large",
      },
    {
      field: "DateCreate",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "large",
      Format: "DateTime",
    },
    {
      field: "Address",
      header: "Dirección",
      headerEn: "Address",
      className: "XXlarge",
    },
    {
      field: "Contact",
      header: "Contacto",
      headerEn: "Contact",
      className: "XXlarge",
    },
    {
      field: "City",
      header: "Ciudad",
      className: "XXlarge",
    },
    {
      field: "State",
      header: "Estado",
      headerEn: "State",
      className: "XXlarge",
    },

    {
      field: "Country",
      header: "País",
      headerEn: "Country",
      className: "large",
    },
    {
      field: "ZipCode",
      header: "ZipCode",
      className: "large",
    },
    {
      field: "Tel",
      header: "Teléfono",
      headerEn: "Phone",
      className: "large",
    },
    {
      field: "Email",
      header: "Correo",
      headerEn: "Email",
      className: "large",
    },

    {
      field: "IsShipTo",
      header: "IsShipTo",
      className: "small",
      frozen: true,
      alignFrozen: "right",
      align: "center",
      Format: "Checkbox",
      filter: false,
    },
    {
      field: "IsBuyer",
      header: "IsBuyer",
      className: "small",
      frozen: true,
      alignFrozen: "right",
      align: "center",
      Format: "Checkbox",
      filter: false,
    },

    {
      field: "UserName",
      header: "Usuario Creación",
      headerEn: "User Create",
      className: "large",
    },
    {
      field: "IdCustomerDetails",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: customerDetails,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "customerDetails", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "customerDetails", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      {showDialog && (
        <CustomerDetailsCrud
          toastRef={toast}
          customerDetailsDialog={showDialog}
          customerDetails={selected}
          setCustomerDetailsDialog={setShowDialog}
          getCustomerDetails={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default CustomerDetailsScreen;
